import { Record, List } from 'immutable';

export default class ExpenseRecord extends Record({
  id: null,
  description: null,
  vat: 0,
  vatRate: 0,
  price: 0,
  dates: new List(),
  typeId: null,
  type: null,
  fromDate: null,
  toDate: null,
  files: new List(),
  resourceCost: null,
  cost: null,
  excludePrice: false,
  excludePayrollTax: false,
  status: null,
}) {
}
